module.exports = __webpack_public_path__ + "img/e57192c.png";